(($, win) => {
    "use strict";

    $.enhancer("localListSearch",
        {
            searchWrapper: null,
            baseUr: null,
            searchInput: null,
            urlHelper: null,
            pageHelper: null,
            loadMoreButton: null,
            resultsList: null,
            page: null,
            updateHistory: function (requestUrl) {
                var formattedUrl = requestUrl.substring(requestUrl.indexOf("?"));

                // Update url, dont update the history
                history.replaceState(null, null, formattedUrl);
            },
            init: function (el) {
                this.load(el);
                this.bindEvents();
            },
            load: function (el) {
                // assign elements to variables
                this.searchWrapper = el;
                this.urlHelper = el.querySelector("#arrangement-list-url"); // TODO: change to a more general naming (contact listing page related files will have to be updated when changing)
                this.pageHelper = el.querySelector("#arrangement-list-page"); // TODO: change to a more general naming (contact listing page related files will have to be updated when changing)
                this.searchInput = el.querySelector("#search-query"); 
                this.loadMoreButton = el.querySelector("#next-btn");
                this.resultsList = el.querySelector("#results-list");

                var currentUrl = win.location.toString();
                // get request url and page
                var requestUrl;
                if (currentUrl.indexOf("?") != -1) {
                    console.log(currentUrl.indexOf("?"));
                    requestUrl = currentUrl.substring(currentUrl.indexOf("?"));
                    this.searchInput.value = decodeURIComponent(requestUrl.substring(requestUrl.indexOf("query=") + 6));
                } else {
                    requestUrl = this.urlHelper.value.replace("{query}", this.searchInput.value);
                    requestUrl = requestUrl.replace("{page}", this.pageHelper.value);
                }
                
                this.updateHistory(requestUrl);

                this.announcer = $("<div>", {
                    "class": "sr-only",
                    "aria-live": "assertive"
                });

                $(this.searchWrapper).append(this.announcer);
                
            },
            bindEvents: function () {
                // call Api on keyup in input element
                if (this.searchInput) {
                    this.searchInput.addEventListener("keyup", $.utils.debounce(this.handleInput, 300, this));
                }

                //load more results if load more button is pressed
                $("#results-list").on("click","#next-btn", this.handleButtonClick.bind(this) );
            },
            handleInput: function (e) {
                var _this = this;
                e.preventDefault();

                var urlhost = location.protocol + '//' + location.host + location.pathname;

                var query = this.searchInput.value;
                var requestUrl = this.urlHelper.value.replace("{query}", query);
                requestUrl = urlhost.replace(/\/?$/, '/') + requestUrl.replace("{page}", this.pageHelper.value);
                
                $.ajax({
                    url: requestUrl,
                    dataType: 'html',
                    cache: false,
                    success: function (data) {
                        _this.resultsList.innerHTML = data;
                        _this.updateHistory(requestUrl);
                        var resultCount = $(_this.resultsList).find(".search-item").length;

                        if (query)
                            _this.announce("Visar " + resultCount + " resultat för sökning: " + query);
                        else 
                            _this.announce("Visar " + resultCount + " resultat");
 
                    },
                    error: function (xhr, status, error) {
                        console.log('Ooops! Något gick fel i sökningen');
                    }
                });
            },
            handleButtonClick: function (e) {
                var _this = this;

                var urlhost = location.protocol + '//' + location.host + location.pathname;


                var page = parseInt(_this.pageHelper.value) + 1;
                _this.pageHelper.value = page;

                var query = _this.searchInput.value;
                var requestUrl = _this.urlHelper.value.replace("{query}", query);
                requestUrl = urlhost.replace(/\/?$/, '/') + requestUrl.replace("{page}", _this.pageHelper.value);


                $.ajax({
                    url: requestUrl,
                    dataType: 'html',
                    success: function (data) {
                        
                        _this.resultsList.innerHTML = data;
                        _this.updateHistory(requestUrl);
                        
                    },
                    error: function (xhr, status, error) {
                        console.log('Ooops! Något gick fel i searchHandler');
                    }
                });
                
            },
            announce: function (text) {
                this.announcer.html(text);
            }

            
        });

})(jQuery, window);
